import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

export default function LoadsWithAssignments() {

  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLoads = async () => {
    try {
      setLoading(true);
      const r = await api.get("/loads");
      setLoads(r.data);
    } catch {
      alert("Failed to fetch loads");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoads();
  }, []);

  const handleClockOut = async (id) => {
    if (!window.confirm("Confirm clock-out?")) return;

    try {
      await api.post(`/assignments/${id}/clock-out`);
      fetchLoads();
    } catch {
      alert("Clock-out failed");
    }
  };

  const allEmployeesClockedOut = (a = []) =>
    a.length > 0 && a.every(x => x.clock_out);

  const getStatus = (load) => {
    if (!load.assignments?.length) return "Pending";
    if (allEmployeesClockedOut(load.assignments)) return "Completed";
    return "In Progress";
  };

  return (
    <div className="container-fluid mt-3 px-2">

      <h4>📦 Load Completion</h4>

      {loading && <p>Loading...</p>}

      {!loading && loads.length === 0 && (
        <div className="alert alert-info">No loads found</div>
      )}

      {/* 🔥 MOBILE VIEW */}
      <div className="d-md-none">

        {loads.map(load => {
          const status = getStatus(load);
          const completed = allEmployeesClockedOut(load.assignments);

          return (
            <div key={load.id} className="card mb-2 p-2 shadow-sm">

              {/* HEADER */}
              <div className="d-flex justify-content-between">
                <strong>PO: {load.po_number || "—"}</strong>

                <span className={`badge ${
                  status === "Completed"
                    ? "bg-success"
                    : status === "In Progress"
                    ? "bg-primary"
                    : "bg-warning"
                }`}>
                  {status}
                </span>
              </div>

              <div className="small text-muted">
                Product: {load.product_type?.name || "—"}
              </div>

              {/* ACTION */}
              <div className="mt-2">
                <Link
                  to={`/loads/${load.id}/edit`}
                  className="btn btn-sm btn-warning w-100"
                >
                  Edit Load
                </Link>
              </div>

              {/* EMPLOYEES */}
              <div className="mt-2">
                {load.assignments?.length ? (
                  load.assignments.map(a => (
                    <div key={a.id} className="border p-2 mb-1 rounded">

                      <div className="d-flex justify-content-between">
                        <strong>{a.employee?.user?.name}</strong>

                        {!a.clock_out && (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleClockOut(a.id)}
                          >
                            Clock Out
                          </button>
                        )}
                      </div>

                      <div className="small">
                        In: {a.clock_in ? new Date(a.clock_in).toLocaleTimeString() : "—"}
                      </div>

                      <div className="small">
                        Out: {a.clock_out ? new Date(a.clock_out).toLocaleTimeString() : "—"}
                      </div>

                      <div className="small">
                        Hours: {a.hours_worked || "—"}
                      </div>

                    </div>
                  ))
                ) : (
                  <div className="alert alert-warning mt-2">
                    No employees assigned
                  </div>
                )}
              </div>

              {/* BILLING */}
              <div className={`mt-2 p-2 text-center rounded ${
                completed ? "bg-success text-white" : "bg-warning"
              }`}>
                $ {load.total_charge}
              </div>

            </div>
          );
        })}

      </div>

      {/* 💻 DESKTOP TABLE VIEW */}
      <div className="d-none d-md-block">

        {loads.map(load => {
          const completed = allEmployeesClockedOut(load.assignments);
          const status = getStatus(load);

          return (
            <div key={load.id} className="card mb-3">

              <div className="card-header d-flex justify-content-between">
                <div>
                  PO: {load.po_number || "—"} | Product: {load.product_type?.name || "—"}
                </div>

                <span className={`badge ${
                  status === "Completed"
                    ? "bg-success"
                    : status === "In Progress"
                    ? "bg-primary"
                    : "bg-warning"
                }`}>
                  {status}
                </span>
              </div>

              <div className="card-body">

                <Link
                  to={`/loads/${load.id}/edit`}
                  className="btn btn-sm btn-warning mb-2"
                >
                  Edit Load
                </Link>

                {load.assignments?.length ? (
                  <table className="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Clock In</th>
                        <th>Clock Out</th>
                        <th>Hours</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {load.assignments.map(a => (
                        <tr key={a.id}>
                          <td>{a.employee?.user?.name}</td>
                          <td>{a.clock_in ? new Date(a.clock_in).toLocaleString() : "—"}</td>
                          <td>{a.clock_out ? new Date(a.clock_out).toLocaleString() : "—"}</td>
                          <td>{a.hours_worked || "—"}</td>
                          <td>
                            {!a.clock_out && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleClockOut(a.id)}
                              >
                                Clock Out
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No employees assigned</p>
                )}

                <div className={`alert mt-2 ${
                  completed ? "alert-success" : "alert-warning"
                }`}>
                  $ {load.total_charge}
                </div>

              </div>
            </div>
          );
        })}

      </div>

    </div>
  );
}